<template>
    <div class="row justify-content-center">
        <div class="col-12 col-lg-8 col-xl-8">
            <div class="min-height-100vh has-header d-flex align-items-center">
                <div class="form-content form-team-content w-100 white-content" v-if="!abono">
                    <ContentOrLoading :style="loading ? 'padding: 100px;' : ''">
                        <template v-if="!loading">
                            <div class="h1 mb-4 text-center text-uppercase">{{ $t('header.mi_abono') }}</div>
                            <div class="thumb-container absolute" :style='"background-image: url(" + manager.logo + ")"'></div>
                            <slot name="buscar-abonado"></slot>
                        </template>
                    </ContentOrLoading>
                </div>
                <div class="form-content form-team-content w-100 white-content" v-else>
                    <div class="h1 mb-4 text-center text-uppercase">{{ $t('header.mi_abono') }}</div>
                    <div class="thumb-container absolute" :style='"background-image: url(" + manager.logo + ")"'></div>
                    <ContentOrLoading :style="loading ? 'padding: 100px;' : ''">
                        <b-row class="mt-3" v-if="!loading">
                            <slot name="content"></slot>
                        </b-row>
                    </ContentOrLoading>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            abono: {
                type: Object,
                default: null
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        }
    }
</script>